<div class="container-fluid">
    <div class="row">
        <div class="col-11 d-flex   personal-details">
            <span class=" personal">
                <img src="assets/settingIcon/user.png">
            </span>

            <div class="personal">
                <h5> <b>Personal details </b></h5>
                <p style="color: #6D6D6D;"> Update Your Personal Information</p>
                <a routerLink="/personaldetails"> <b style="color: #286676;">Manage Personal details </b> </a>
            </div>


        </div>
    </div>
    <div class="row">
        <div class="col-11 d-flex   personal-details">
            <span class=" personal">
                <img src="assets/settingIcon/preference.png"> <!-- Changed icon since notification doesn't fit well, or maybe keeping it is fine. Reusing preference or mobile icon if it exists -->
            </span>

            <div class="personal">
                <h5> <b>App Settings </b></h5>
                <p style="color: #6D6D6D;"> Manage Contact Info and About Text for the Tourist and Tourguide Apps
                </p>
                <a routerLink="/admin/subsetting/notification" style="text-decoration: none;"> <b style="color: #286676;">Manage App Settings </b></a>
            </div>


        </div>
    </div>
    <div class="row">
        <div class="col-11 d-flex   personal-details">
            <span class=" personal">
                <img src="assets/settingIcon/preference.png">
            </span>

            <div class="personal">
                <h5> <b>Terms & Conditions </b></h5>
                <p style="color: #6D6D6D;"> Manage Terms and Conditions</p>
                <a routerLink="/admin/subsetting/preference" style="text-decoration: none;"> <b
                        style="color: #286676;">Manage Terms & Conditions </b></a>
            </div>


        </div>
    </div>
    <div class="row">
        <div class="col-11 d-flex   personal-details">
            <span class=" personal">
                <img src="assets/settingIcon/security.png">
            </span>

            <div class="personal">
                <h5> <b>Security </b></h5>
                <p style="color: #6D6D6D;"> Change Your Language</p>
                <b style="color: #286676;">Manage Personal details </b>
            </div>


        </div>
    </div>
    <div class="row">
        <div class="col-11 d-flex   personal-details">
            <span class=" personal">
                <img src="assets/settingIcon/preference.png">
            </span>

            <div class="personal">
                <h5> <b>Cancellation Reasons </b></h5>
                <p style="color: #6D6D6D;"> Manage Cancellation Reasons</p>
                <a routerLink="/admin/subsetting/cancellation-reasons" style="text-decoration: none;"> <b style="color: #286676;">Manage Cancellation Reasons </b></a>
            </div>

        </div>
    </div>
</div>